import React from "react";
import DimensionInfo from "../models/DimensionInfo"
import DimensionsList from "../components/DimensionsList"
import DimensionsMap from "../components/DimensionsMap"
import {HeaderContext, ResultMode} from "../store/HeaderContext";

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import DimensionCard from "./DimensionCard";

interface DimensionsContainerProps {
    dimensions: DimensionInfo[];   // Optional prop for passing dimensions directly
}

const DimensionsContainer: React.FC<DimensionsContainerProps> = ({dimensions}) => {
    const headerCtx = React.useContext(HeaderContext);

    return (
        <>
            {headerCtx.mode == ResultMode.Map && (
                <Row>
                    <DimensionsMap data={dimensions}/>
                </Row>
            )}

            <Row>
                {dimensions.map((item, index) => (
                    <Col xs={12} sm={12} md={6} lg={4} key={index}>
                        <DimensionCard data={item}/>
                    </Col>))}
            </Row>
        </>
    );
};

export default DimensionsContainer;
